import { Box, Typography } from '@mui/material';
import Grid from '@mui/material/Unstable_Grid2';
import React, { useEffect, useState } from 'react';
import { getMapDataSelected } from '../../reducer/mapDataSelectedSlice';
import { useSelector } from 'react-redux';
import { getIAAM } from '../../reducer/iaamSlice';
import { getWeekOfYear } from '../../reducer/weekOfYearSlice';
import { getAreaLevel } from '../../reducer/areaLevelSlice';


let eocWOActivity = {};
let activityList = [];
function MonitorDataShow() {
    const iaam = useSelector(getIAAM);
    const mapDataSelected = useSelector(getMapDataSelected);
    const woy = useSelector(getWeekOfYear);
    const areaLevel = useSelector(getAreaLevel);
    const [areaData, setAreaData] = useState({});
    const [attributeData, setAttributeData] = useState([]);
    const [propertiesData, setPropertiesData] = useState({});

    // const attributeData = [
    //     {
    //         attribute: "patient",
    //         name_th: "จำนวนผู้ป่วย",
    //         unit_th: "ราย",
    //         name_us: "Cases",
    //         unit_us: "head"
    //     },
    //     {
    //         attribute: "population",
    //         name_th: "จำนวนประชากร",
    //         unit_th: "ราย",
    //         name_us: "Population",
    //         unit_us: "head"
    //     }
    // ]
    // const [type, setType] = useState();

    useEffect(() => {
        const setAreaName = (properties) => {
            if (properties.tambon_code) {
                setAreaData({
                    tambon_name: properties.tambon_namt,
                    amp_name: properties.amp_namt,
                    prov_name: properties.prov_namt
                })
            } else {
                if (properties.amp_namt) {
                    setAreaData({
                        amp_name: properties.amp_namt
                    })
                } else if (properties.prov_namt) {
                    setAreaData({
                        prov_name: properties.prov_namt
                    })
                } else {
                    setAreaData({
                        region_name: properties.health_region_name
                    })
                }
            }
        }
        const setAttributeQualify = (properties) => {
            // console.log(properties);
            let attrTmp = []
            if (properties.tambon_namt) {
                attrTmp = [{
                    attribute: "npatients",
                    name_th: "จำนวนผู้ป่วย",
                    name_us: "Patients",
                    unit_th: "ราย"
                },
                {
                    attribute: "median",
                    name_th: "มัธยฐาน",
                    name_us: "Median",
                    unit_th: "ราย"
                },
                {
                    attribute: "epidemic_period",
                    name_th: "ระยะเวลาระบาดต่อเนื่อง",
                    name_us: "Period",
                    unit_th: "วัน"
                }]
            } else {
                let unit = "ตำบล";
                if (properties.health_region_name !== undefined) {
                    unit = "จังหวัด";
                } else if (properties.prov_namt !== undefined) {
                    unit = "อำเภอ";
                }
                attrTmp = [{
                    attribute: "total_count",
                    name_th: "จำนวน" + unit,
                    name_us: "Patients"
                },
                {
                    attribute: "eoc_count",
                    name_th: "จำนวน" + unit + "ที่เข้าเกณฑ์ EOC",
                    name_us: "Median"
                },
                {
                    attribute: "eoc_start_week_year",
                    name_th: "สัปดาห์ที่เข้าเกณฑ์",
                    name_us: "Period"
                }]
            }
            return attrTmp;
        }
        const setAttributeEOC = (properties) => {
            let attrTmp = []
            if (properties.status) {
                attrTmp = [{
                    attribute: "start_eoc_week_year",
                    name_th: "สัปดาห์ที่เปิด EOC",
                    name_us: "Patients"
                },
                {
                    attribute: "closed_eoc_week_year",
                    name_th: "สัปดาห์ที่ปิด EOC",
                    name_us: "Median"
                },
                {
                    attribute: "creator_name",
                    name_th: "เจ้าหน้าที่เปิด EOC",
                    name_us: "Median"
                },
                {
                    attribute: "incident_commander_str",
                    name_th: "ผู้บังคับบัญชาเหตุการณ์",
                    name_us: "Median"
                },
                {
                    attribute: "participating_org",
                    name_th: "หน่วยงานที่มีส่วนร่วม",
                    name_us: "Median",
                    key: "po_type_id",
                    value: "po_type_name"
                }]
                // } else {
                // attrTmp = [{
                //     attribute: "count",
                //     attrubute_name: "type",
                //     attrubute_name_value: "activity"
                //     // name_th: "สัปดาห์ที่เปิด EOC",
                //     // name_us: "Patients"
                // }]
            }

            return attrTmp;
        }

        const callEocData = async (properties, attr) => {
            iaam.getAccessToken(async (err, access_token) => {
                if (!err) {
                    let options = {
                        method: 'GET',
                        headers: {
                            'Content-Type': 'application/json',
                            'Authorization': `bearer ${access_token}`
                        }
                    }
                    const resp = await fetch(`${process.env.REACT_APP_API_URL}/my_eoc/get_eoc_by_eoc_id/${properties.eoc_id}?is_history=false`, options);
                    const json = await resp.json();
                    let eocData = json[0];
                    eocData["start_eoc_week_year"] = `${eocData.start_eoc_week}/${eocData.start_eoc_year + 543}`;
                    eocData["incident_commander_str"] = eocData.incident_commander.ic_name;
                    if (eocData.closed_eoc_week === undefined) {
                        eocData["closed_eoc_week_year"] = "-";
                    } else {
                        eocData["closed_eoc_week_year"] = `${eocData.closed_eoc_week}/${eocData.closed_eoc_year + 543}`;
                    }
                    setPropertiesData({ ...properties, ...eocData });
                    setAttributeData(attr);
                }
            })
        }

        const callActivity = async (properties, attr) => {
            iaam.getAccessToken(async (err, access_token) => {
                if (!err) {
                    let attr_area = "ddc_region_code";
                    let attr_activity = "org_id";
                    if (Object.keys(eocWOActivity).length === 0) {
                        let eoc_level = "02";
                        if (areaLevel === "province") {
                            attr_area = "province_code";
                            eoc_level = "03";
                            attr_activity = "area_code";
                        } else if (areaLevel === "amphur") {
                            attr_area = "amphur_code";
                            eoc_level = "04";
                            attr_activity = "area_code";
                        } else if (areaLevel === "tambon") {
                            attr_area = "tambon_code";
                            eoc_level = "05";
                            attr_activity = "area_code";
                        }
                        let options = {
                            method: 'GET',
                            headers: {
                                'Content-Type': 'application/json',
                                'Authorization': `bearer ${access_token}`
                            }
                        }
                        const wo_eoc_res = await fetch(`${process.env.REACT_APP_API_URL}/monitor/get_activity_wo_eoc_timeline?eoc_level=${eoc_level}&week=${woy.week}&year=${woy.year}`, options);
                        const wo_eoc = await wo_eoc_res.json();
                        // console.log(wo_eoc);
                        let wo_eoc_map = {};
                        for (let index = 0; index < wo_eoc.length; index++) {
                            const element = wo_eoc[index];
                            // wo_eoc_map[`${element.ep_year}-${element.ep_week}`] = element;
                            if (wo_eoc_map[`${element.ep_year}-${element.ep_week}`] === undefined) {
                                wo_eoc_map[`${element.ep_year}-${element.ep_week}`] = [];
                            }
                            wo_eoc_map[`${element.ep_year}-${element.ep_week}`].push(element);
                        }
                        eocWOActivity = { ...wo_eoc_map };
                    }
                    if (activityList.length === 0) {
                        const responseActivityName = await fetch(`${process.env.REACT_APP_API_URL}/config/my_activity_config`);
                        const dataActivityName = await responseActivityName.json();
                        // const config = dataActivityName.config;
                        activityList = dataActivityName.config;
                    }

                    let activityListData = eocWOActivity[`${woy.year}-${woy.week}`];
                    let activityShow = {};
                    for (let index = 0; index < activityList.length; index++) {
                        const element = activityList[index];
                        activityShow[element] = 0;
                    }
                    for (let index = 0; index < activityListData.length; index++) {
                        const element = activityListData[index];
                        if (element[attr_activity] === properties[attr_area]) {
                            const activityData = element.activity;
                            for (let j = 0; j < activityData.length; j++) {
                                const type = activityData[j];
                                activityShow[type]++;
                            }
                        }
                    }
                    // let tmp = [];
                    let tmpActivity = {};
                    let index = 0;
                    let tmpAttr = [{
                        attribute: `activity`,
                        name_th: "กิจกรรมทั้งหมด",
                        name_us: "Median",
                        unit_th: "ครั้ง"
                    }];
                    let sum = 0;
                    for (const key in activityShow) {
                        if (Object.prototype.hasOwnProperty.call(activityShow, key)) {
                            const element = activityShow[key];
                            if (element !== 0) {
                                tmpActivity[`activity-${index}`] = element
                                tmpAttr.push({
                                    attribute: `activity-${index}`,
                                    name_th: `- ${key}`,
                                    name_us: "Median",
                                    unit_th: "ครั้ง"
                                })
                                sum += element;
                                index++;
                            }
                        }
                    }
                    tmpActivity[`activity`] = sum
                    // console.log(tmpActivity);
                    // console.log(tmpAttr)
                    // console.log(properties);
                    // console.log({...properties, activity: tmp});
                    setPropertiesData({ ...properties, ...tmpActivity });
                    setAttributeData([...attr, ...tmpAttr]);
                    // setPropertiesData({...properties, activity: tmp});
                    // setAttributeData(attr);
                    // console.log(tmp);
                    // console.log(activityShow);
                    // console.log(properties);
                }
            })

        }

        if (mapDataSelected.length !== 0) {
            let propertiesTmp = {};
            let attrTmp = [];
            for (let index = 0; index < mapDataSelected.length; index++) {
                const element = mapDataSelected[index];
                propertiesTmp = { ...propertiesTmp, ...element.properties };
                if (Object.keys(areaData).length === 0) {
                    setAreaName(element.properties);
                }
                if (element.id.indexOf('eoc_qualify') !== -1) {
                    propertiesTmp = {
                        ...propertiesTmp,
                        eoc_start_week_year: `${element.properties.eoc_start_week}/${element.properties.year + 543}`
                    }
                    attrTmp = [...attrTmp, ...setAttributeQualify(element.properties)];
                } else if (element.id.indexOf('eoc_active') !== -1) {
                    attrTmp = [...attrTmp, ...setAttributeEOC(element.properties)];
                }
            }
            if (propertiesTmp.eoc_id !== undefined) {
                // console.log(propertiesTmp);
                if (propertiesTmp.status) {
                    callEocData(propertiesTmp, attrTmp);
                } else {
                    callActivity(propertiesTmp, attrTmp);
                }
            } else {
                setPropertiesData(propertiesTmp);
                setAttributeData(attrTmp);
            }
        } else {
            setAreaData({});
            setPropertiesData({});
            setAttributeData([]);
        }
    }, [mapDataSelected])

    // const content = () => {
    //     // console.log(mapDataSelected);
    //     if (mapDataSelected.length !== 0) {

    //         // console.log(mapDataSelected.values_);
    //         // if (mapDataSelected.values_) {

    //         // }
    //         // console.log(mapDataSelected.values_);
    //         // let selectedType = "";
    //         // if (mapDataSelected.values_.features) {
    //         //     selectedType = mapDataSelected.values_.features[0].values_.datatype;
    //         // } else {
    //         //     selectedType = mapDataSelected.values_.datatype
    //         // }
    //         // if (selectedType === "morbidity") {
    //         //     return (
    //         //         <MorbidityContent data={mapDataSelected.values_.attributes} />
    //         //     )
    //         // } else if (selectedType === "compare") {
    //         //     return (
    //         //         <CompareContent data={mapDataSelected.values_.attributes} />
    //         //     )
    //         // } else if (selectedType === "patient") {
    //         //     return (
    //         //         <PatientContent data={mapDataSelected.values_.attributes} />
    //         //     )
    //         // } else if (selectedType === "spotmap") {
    //         //     return (
    //         //         <SpotmapContent data={mapDataSelected.values_} />
    //         //     )
    //         // } else if (selectedType === 'cluster') {
    //         //     return (
    //         //         <ClusterContent data={mapDataSelected.values_} />
    //         //     )
    //         // } else if (selectedType === 'index') {
    //         //     return (
    //         //         <IndexContent data={mapDataSelected.values_} />
    //         //     )
    //         // }
    //     } else {
    //         return (<></>)
    //     }
    // }

    // console.log(propertiesData);

    return (
        <Box
            sx={{ width: 350 }}
            role="presentation"
        >
            {/* {
                content()
            } */}
            <Grid container spacing={2}>
                <Grid xs={12} sx={{
                    backgroundColor: '#cd6c4a'
                }}>
                    <Typography variant="h5" className="mb-2 font-primary" sx={{
                        padding: 2,
                        paddingBottom: 0,
                        color: 'white'
                    }}>
                        {
                            areaData.tambon_name !== undefined ?
                                `ต.${areaData.tambon_name}` :
                                areaData.amp_name !== undefined ?
                                    `อ.${areaData.amp_name}` :
                                    areaData.prov_name !== undefined ?
                                        `จ.${areaData.prov_name}` : `${areaData.region_name}`
                        }
                    </Typography>
                    <Typography variant="h6" className="mb-2 font-primary" sx={{
                        fontWeight: 'normal',
                        paddingLeft: 2,
                        paddingRight: 2,
                        color: 'white'
                    }}>
                        {
                            areaData.tambon_name !== undefined ?
                                `อ.${areaData.amp_name} จ.${areaData.prov_name}` : ``
                        }
                    </Typography>
                </Grid>
                {
                    attributeData.map((attribute, index) => {
                        // console.log(attribute);
                        // console.log(propertiesData);
                        return (
                            <React.Fragment key={index}>
                                <Grid xs={attribute.unit_th !== undefined ? 5 : 6}>
                                    <Typography variant='body1' className="font-primary" sx={{
                                        paddingLeft: 2
                                    }}>
                                        {attribute.name_th}
                                    </Typography>
                                </Grid>
                                <Grid xs={5}>
                                    {
                                        !Array.isArray(propertiesData[attribute.attribute]) ?
                                            <Typography variant='body1' className="font-primary" sx={{
                                                textAlign: 'right'
                                            }}>
                                                {
                                                    Object.keys(propertiesData).length !== 0 ?
                                                        `${propertiesData[attribute.attribute].toLocaleString()}` : ``
                                                }
                                            </Typography> : propertiesData[attribute.attribute].map((data) => {
                                                // console.log(data);
                                                return (
                                                    <Typography key={data[attribute.key]} variant='body1' className="font-primary" sx={{
                                                        textAlign: 'right'
                                                    }}>
                                                        {
                                                            Object.keys(data).length !== 0 ?
                                                                `${data[attribute.value].toLocaleString()}` : ``
                                                        }
                                                    </Typography>
                                                )
                                            })
                                    }
                                </Grid>
                                {
                                    attribute.unit_th !== undefined ?
                                        <Grid xs={2}>
                                            <Typography variant='body1' className="font-primary">
                                                {attribute.unit_th}
                                            </Typography>
                                        </Grid> : <></>
                                }
                            </React.Fragment>
                        )
                    })
                }
            </Grid>
            <Grid sx={{
                position: 'absolute',
                width: '100%',
                bottom: 10
            }} container spacing={0}>
                <Grid xs={12} sx={{
                    paddingLeft: "10px",
                    paddingRight: "10px"
                }}>
                    <Typography variant="body2" className="font-primary" sx={{
                        color: 'black'
                    }}>
                        {
                            areaData.tambon_name !== undefined ?
                                "" : "เกณฑ์ยกระดับ EOC"
                        }
                    </Typography>
                    <Typography variant="body2" className="font-primary" sx={{
                        color: 'black',
                        fontWeight: 'normal'
                    }}>
                        {
                            areaData.tambon_name !== undefined ?
                                <>
                                    <Typography variant="body2" className="font-primary" sx={{
                                        color: 'black',
                                        fontWeight: 'normal'
                                    }}>
                                        * ตำบลที่เป็นพื้นที่ระบาด : ตำบลที่มีรายงานผู้ป่วยโรคไข้เลือดออกเกินค่ามัธยฐาน 5 ปีย้อนหลังในช่วง 4 สัปดาห์ล่าสุด และมีการระบาดต่อเนื้่องมากกว่า 28 วัน (พบผู้ป่วยรายใหม่ต่อเนื่องกัน โดยวันที่พบผู้ป่วย (วันที่วินิจฉัยสงสัยไข้เลือดออก) ของผู้ป่วยแต่ละรายทิ้งระยะห่างกันไม่เกิน 28 วัน และยังควบคุมโรคไม่ได้)
                                    </Typography>
                                    <Typography variant="body2" className="font-primary" sx={{
                                        color: 'black',
                                        fontWeight: 'normal'
                                    }}>
                                        * 4 สัปดาห์ระบาด : 4 สัปดาห์ล่าสุดซี่งไม่นับสัปดาห์ปัจจุบัน
                                    </Typography>
                                </>
                                :
                                areaData.amp_name !== undefined ?
                                    `* มีตำบลที่เป็นพื้นที่ระบาดมากกว่าร้อยละ 25 ของจำนวนตำบลในอำเภอ` :
                                    areaData.prov_name !== undefined ?
                                        <>
                                            <Typography variant="body2" className="font-primary" sx={{
                                                color: 'black',
                                                fontWeight: 'normal'
                                            }}>
                                                * มีอำเภอที่เข้าเกณฑ์เปิด EOC มากกว่าร้อยละ 25 ของจำนวนอำเภอในจังหวัด หรือ มีการระบาดสูงกว่าค่า Med ย้อนหลัง 5 ปี ต่อเนื่องมากว่า 4 สัปดาห์
                                            </Typography>
                                            <Typography variant="body2" className="font-primary" sx={{
                                                color: 'black',
                                                fontWeight: 'normal'
                                            }}>
                                                หมายเหตุ: จังหวัดที่มีอำเภอน้อยกว่า 5 อำเภอพิจารณายกระดับเื่อมีอำเภอที่เข้าเกณฑ์ ยกระดับเมื่อมีอำเภอที่เข้าเกณฑ์ ยกระดับ EOC ตั้งแต่ 3 อำเภอขึ้นไป
                                            </Typography>
                                        </>
                                        :
                                        <>
                                            <Typography variant="body2" className="font-primary" sx={{
                                                color: 'black',
                                                fontWeight: 'normal'
                                            }}>
                                                * มีจังหวัดที่เข้าเกณฑ์เปิด EOC มากกว่าร้อยละ 25 ของจำนวนจังหวัดในเขตสุขภาพ หรือ มีการระบาดสูงกว่าค่า Med ย้อนหลัง 5 ปี ต่อเนื่องมากว่า 4 สัปดาห์
                                            </Typography>
                                            <Typography variant="body2" className="font-primary" sx={{
                                                color: 'black',
                                                fontWeight: 'normal'
                                            }}>
                                                หมายเหตุ: สคร. ที่มีจังหวัดน้อยกว่า 5 จังหวัดพิจารณายกระดับเมื่อมีจังหวัดที่เข้าเกณฑ์ ยกระดับเมื่อมีอำเภอที่เข้าเกณฑ์ ยกระดับ EOC ตั้งแต่ 3 จังหวัดขึ้นไป
                                            </Typography>
                                        </>
                        }
                    </Typography>
                </Grid>
            </Grid>
        </Box>
    )
}

export default MonitorDataShow
